<template>
	<div class="org-settings-usage">
		<OrganizationUsageTable :usage-data="usageData" :org-code="orgCode" :loading="usageLoading" @month-year-change="onMonthYearChange" />
		<FormUsageTable :forms-usage="usageData.FormsUsage" :loading="formsLoading" :show-organization-audit-log="canViewOrganizationAuditLog" class="forms-usage-section" @org-audit-log="showOrganizationAuditLog = true" />
		<OrganizationAuditLogDialog
			v-if="showOrganizationAuditLog"
			show
			:org-code="orgCode"
			:is-org-owner="isOrgOwner"
			@closed="showOrganizationAuditLog = false"
		/>
	</div>
</template>

<script lang="ts">
	import type { PropType } from 'vue';
	import { defineComponent, onMounted, ref, inject } from 'vue';
	import FormUsageTable from '../components/FormUsageTable.vue';
	import OrganizationUsageTable from './OrganizationUsageTable.vue';
	import type { UsageViewModel } from '@cognitoforms/types/server-types/model/organization-settings/usage-view-model';
	import OrganizationAuditLogDialog from 'src/components/dialogs/OrganizationAuditLogDialog.vue';
	import { organizationAuditLogKey } from 'src/utilities/injection-keys';
	import { checkRole } from 'src/views/admin/utils/role-check';
	import { ClientRole } from '@cognitoforms/types/server-types/core/services/client-role';

	export default defineComponent({
		components: {
			FormUsageTable,
			OrganizationAuditLogDialog,
			OrganizationUsageTable
		},
		props: {
			usageData: { type: Object as PropType<UsageViewModel>, default: null },
			orgCode: { type: String, default: null },
			usageLoading: { type: Boolean, default: true },
			formsLoading: { type: Boolean, default: true }
		},
		emits: ['component-loaded', 'month-year-change'],
		setup(props, { emit }) {
			onMounted(() => emit('component-loaded'));

			const organizationAuditLog = inject(organizationAuditLogKey)!;
			const isOrgOwner = checkRole(ClientRole.Owner);

			return {
				onMonthYearChange: (payload: { year: number, month: number }) => emit('month-year-change', payload),
				canViewOrganizationAuditLog: organizationAuditLog.canViewOrganizationAuditLog,
				showOrganizationAuditLog: ref(false),
				isOrgOwner
			};
		}
	});
</script>

<style lang="scss">
.org-settings-usage {

	.i-simple {
		vertical-align: bottom;
	}

	.forms-usage-section {
		padding-top: 3rem;
	}
}
</style>